import React from 'react'

import { brandSecondary } from '../../utils/style-utils'

export default function CircleSolid(props) {
  return (
    <svg
      viewBox="0 0 512 512"
      fill={brandSecondary}
      height="12px"
      width="12px"
      {...props}
    >
      <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z" />
    </svg>
  )
}
